module.exports = __webpack_public_path__ + "img/MRBTC.4def8dd2.svg";